import Vue from "vue";
import {PersonnelService,} from "@/common/api.service";
import {CANCEL_PERSON_VEHICLE_EDIT_STATE, DELETE_PERSON_VEHICLE, FETCH_PERSON_VEHICLE_LIST, SAVE_EDITED_PERSON_VEHICLE, SAVE_NEW_PERSON_VEHICLE, UPDATE_PERSON_VEHICLE} from "./actions.js";
import {
    FETCH_PERSON_VEHICLES_END,
    LOAD_PERSON_VEHICLE_TO_EDIT,
    RESET_DEFAULT_NEW_PERSON_VEHICLE,
    RESET_DEFAULT_PERSON_VEHICLE_TO_EDIT,
    RESET_DEFAULT_VEHICLE_TO_EDIT,
    TOGGLE_EDIT_PERSON_VEHICLE_DIALOG,
    TOGGLE_NEW_PERSON_VEHICLE_DIALOG,
    TOGGLE_PERSON_VEHICLE_EDIT_STATE,
    UPDATE_ADD_PERSON_VEHICLE_FIELD,
    UPDATE_EDIT_PERSON_VEHICLE_FIELD,
    UPDATE_NEW_PERSON_VEHICLE,
} from "./mutations.js";

import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const functions = {
    compareDatesDesc(a, b) {
        // Use toUpperCase() to ignore character casing
        const startDatetimeA = moment(a.startDatetime);
        const startDatetimeB = moment(b.startDatetime);

        let comparison = 0;
        if (startDatetimeA.isAfter(startDatetimeB)) {
            comparison = -1;
        } else if (startDatetimeA.isBefore(startDatetimeB)) {
            comparison = -0;
        }
        return comparison;
    },
    compareDatesAsc(a, b) {
        // Use toUpperCase() to ignore character casing
        const startDatetimeA = moment(a.startDatetime);
        const startDatetimeB = moment(b.startDatetime);

        let comparison = -1;
        if (startDatetimeA.isAfter(startDatetimeB)) {
            comparison = -0;
        } else if (startDatetimeA.isBefore(startDatetimeB)) {
            comparison = -1;
        }
        return comparison;
    }
};

const state = {
    loadingEcsCompany: false,
    personVehicleList: [],
    jobList: [],
    personnelList: [],
    teamList: [],
    personnelCount: 0,
    editStateVehicle: {
        // employmentType: false,
        // weeklyHours: false,
        startDate: false,
        engineSize: false,
        fuelType: false,
        mileageRate: false,
        mileageCurrency: false,
        vatMileage: false,
        ownershipType: false,
        comments: false,
        // endDatetime: false,
        // comments: false,
    },
    editPersonVehicle: {
        registrationNumber: '',
        startDate: false,
        engineSize: false,
        fuelType: false,
        mileageRate: false,
        mileageCurrency: false,
        vatMileage: false,
        ownershipType: false,
        comments: false,
    },

    addPersonVehicle: {},
    editPersonVehicleDialog: false,
    addPersonVehicleDialog: false,
    fiscalYearList: [
        2018, 2019, 2020
    ],

    fuelTypeList: [
        'Petrol', 'Diesel', 'Electric', 'Hybrid'
    ],
    ownershipTypeList: [
        'Personal', 'Company'
    ],

};

const getDefaultState = () => {
    return {
        defaultPersonVehicle: {
            registrationNumber: undefined,
            engineSize: undefined,
            fuelType: undefined,
            mileageRate: undefined,
            mileageCurrency: undefined,
            vatMileage: undefined,
            ownershipType: undefined,
            startDate: undefined,
            isCurrent: undefined,
            comments: undefined,
        },
    }
};

const getters = {
    addPersonVehicleDialog(state) {
        return state.addPersonVehicleDialog;
    },
    fuelTypeList(state) {
        return state.fuelTypeList;
    },
    editPersonVehicleDialog(state) {
        return state.editPersonVehicleDialog;
    },
    personVehicleList(state) {
        return state.personVehicleList;
    },
    personVehicleListSorted(state, sortOrder) {
        // `this` points to the vm instance
        let frozenVehicleList = Object.freeze(state.personVehicleList);
        let jsonedVehicleList = JSON.parse(JSON.stringify(frozenVehicleList));

        if (sortOrder == 'asc') {
            return jsonedVehicleList.sort(functions.compareDatesAsc);
        } else {
            return jsonedVehicleList.sort(functions.compareDatesDesc);
        }
    },
    editStateVehicle(state) {
        return state.editStateVehicle;
    },

    ownershipTypeList(state) {
        return state.ownershipTypeList;
    }
};

const actions = {
    [FETCH_PERSON_VEHICLE_LIST]({commit}, personId) {
        
        if (personId == undefined)
            return;
        
        return PersonnelService.getPersonVehicles(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_VEHICLES_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch vehicle list'});
            });
    },
    [CANCEL_PERSON_VEHICLE_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_VEHICLE_LIST, params.personId);
        commit(TOGGLE_PERSON_VEHICLE_EDIT_STATE, params.field);
    },
    [SAVE_NEW_PERSON_VEHICLE]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonVehicle = state.addPersonVehicle;
        return PersonnelService.savePersonVehicle(newPersonVehicle)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_VEHICLE_LIST, newPersonVehicle.personId);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Vehicle failed to save'});
            });
    },

    [SAVE_EDITED_PERSON_VEHICLE]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonVehicle = state.editPersonVehicle;
        return PersonnelService.updatePersonVehicle(editedPersonVehicle)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});                
                commit(RESET_DEFAULT_PERSON_VEHICLE_TO_EDIT);
                dispatch(FETCH_PERSON_VEHICLE_LIST, editedPersonVehicle.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Vehicle failed to update'});
            });
    },
    [UPDATE_PERSON_VEHICLE]({commit, dispatch}, params) {
        return PersonnelService.updatePersonVehicle(state.editPersonVehicle)
            .then(({data}) => {
                commit(RESET_DEFAULT_VEHICLE_TO_EDIT);
                dispatch(FETCH_PERSON_VEHICLE_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Vehicle failed to update'});
            });
    },

    [DELETE_PERSON_VEHICLE]({commit, dispatch}, params) {
        return PersonnelService.deletePersonVehicle(params.vehicleId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_VEHICLE_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Vehicle failed to delete'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_NEW_PERSON_VEHICLE_DIALOG](state) {
        state.addPersonVehicleDialog = !state.addPersonVehicleDialog;
    },
    [TOGGLE_EDIT_PERSON_VEHICLE_DIALOG](state) {
        state.editPersonVehicleDialog = !state.editPersonVehicleDialog;
    },

    [RESET_DEFAULT_NEW_PERSON_VEHICLE](state, personId) {
        state.addPersonVehicle = getDefaultState().defaultPersonVehicle;
        state.addPersonVehicle.fiscalYear = 2019;
        state.addPersonVehicle.personId = personId;
    },
    [RESET_DEFAULT_PERSON_VEHICLE_TO_EDIT](state) {
        state.editPersonVehicle = getDefaultState().defaultPersonVehicle;
    },

    [LOAD_PERSON_VEHICLE_TO_EDIT](state, vehicleId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personVehicleList.find((list) =>
            list.vehicleId == vehicleId);

        state.editPersonVehicle = itemToEdit;
    },
    [TOGGLE_PERSON_VEHICLE_EDIT_STATE](state, field) {
        state.editStateVehicle[field] = !state.editStateVehicle[field];
    },
    [UPDATE_EDIT_PERSON_VEHICLE_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonVehicle[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonVehicle[data.key] = data.value;
        }
    },
    [UPDATE_ADD_PERSON_VEHICLE_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonVehicle[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonVehicle[data.key] = data.value;
        }
    },
    [FETCH_PERSON_VEHICLES_END](state, data) {
        state.personVehicleList = data;
        //state.articlesCount = articlesCount;
        state.isLoading = false;
    },
    [UPDATE_NEW_PERSON_VEHICLE](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonVehicle[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonVehicle[data.key] = data.value;
        }
    },
};


export default {
    state,
    getters,
    actions,
    mutations,
};
